import React, { useEffect } from "react";
import { Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import { useLocation } from "react-router-dom";
import ContactChat from "../Hellper/ContactChat";

const Clearance = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        padding: "20px",
        maxWidth: "1300px",
        margin: "auto",
        marginTop: "10px",
        "@media (min-width: 1024px)": {
          marginTop: "10px",
        },
      }}
    >
      {/* Title */}
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontWeight: "bold",
          fontSize: "1.75rem",
        }}
      >
        Customs Clearance
      </Typography>

      {/* Main Paragraph */}
      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.1rem",
          "@media (min-width: 1024px)": { fontSize: "1.4rem" },
        }}
      >
        Navigating export and import regulations can be complex—UK TO MARS LTD
        makes it simple. Our customs clearance team handles all documentation
        and compliance for UK exports and international shipments.
      </Typography>

      {/* Services Section */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.75rem",
          fontWeight: "bold",
        }}
      >
        Our customs services include:
      </Typography>

      <List sx={{ padding: "0 0 0 16px" }}>
        {[
          "Preparation and submission of all required customs paperwork",
          "HS code classification and duty/tax calculations",
          "Coordination with UK and destination country customs authorities",
          "Handling of restricted or regulated products",
          "Ongoing support to ensure your shipments clear borders without delay",
        ].map((service) => (
          <ListItem key={service} sx={{ padding: "0" }}>
            <ListItemText
              primary={
                <Typography
                  component="span"
                  sx={{
                    color: "#1D1616",
                    fontSize: { xs: "1.2rem", lg: "1.4rem" },
                    lineHeight: "1.5",
                    display: "block",
                  }}
                >
                  • {service}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Closing Paragraph */}
      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.1rem",
          "@media (min-width: 1024px)": { fontSize: "1.4rem" },
          mt: 2,
        }}
      >
        With our experience and up-to-date regulatory knowledge, you can rely on
        us for fast, transparent, and compliant customs clearance on every
        shipment.
      </Typography>

      <ContactChat />
    </Box>
  );
};

export default Clearance;
